export default "__VITE_PUBLIC_ASSET__b90de8d3__"